import Markdown from "react-markdown";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export function SelfRepairFlowStep({
    id,
    name,
    description,
    images = [],
    substeps = [],
    onClickImage,
}) {
    return (
        <div className="relative ml-8">
            <div className="absolute flex justify-center items-center w-8 h-8 rounded-full -left-12 top-0 bg-gray-100 border border-gray-200">
                <div className="w-2 h-2 bg-gray-300 rounded-full" />
            </div>

            <h2 className="text-2xl">{name}</h2>

            {images.length === 0 ? (
                <Markdown>{description}</Markdown>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-3 gap-8">
                    <div>
                        {images.length === 1 ? (
                            <img
                                src={images[0]?.path}
                                className="w-full h-48 rounded-lg object-cover cursor-pointer"
                                onClick={() =>
                                    onClickImage?.({ index: 0, images: images, name, description })
                                }
                            />
                        ) : (
                            <Swiper
                                className="w-full max-w-full"
                                autoplay={false}
                                autoHeight
                                loop={images.length > 1}
                                modules={[
                                    Navigation,
                                    Pagination,
                                    A11y,
                                    Autoplay,
                                ]}
                                spaceBetween={0}
                                slidesPerView={1}
                                pagination={{
                                    clickable: true,
                                    el: `#swiper-bullet-container-${id}`,
                                    bulletClass: "swiper-custom-bullet-rect",
                                    bulletActiveClass:
                                        "swiper-custom-bullet-rect--active",
                                }}
                            >
                                {images.map((image, index) => (
                                    <SwiperSlide key={image.id}>
                                        <img
                                            src={image.path}
                                            className="w-full h-48 rounded-lg object-cover cursor-pointer"
                                            onClick={() =>
                                                onClickImage?.({
                                                    index,
                                                    images: images,
                                                    name,
                                                    description,
                                                })
                                            }
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        )}

                        <div
                            id={`swiper-bullet-container-${id}`}
                            className="flex items-center justify-center gap-2 mt-2"
                        />
                    </div>

                    <div className="col-span-2">
                        <Markdown>{description}</Markdown>
                    </div>
                </div>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8">
                {substeps?.map((child, index) => (
                    <div key={child.id}>
                        {child.images?.length === 1 ? (
                            <img
                                src={child.images[0].path}
                                className="w-full h-48 rounded-lg object-cover cursor-pointer"
                                onClick={() =>
                                    onClickImage?.({
                                        index: 0,
                                        images: child.images,
                                        name: child.name,
                                        description: child.description,
                                    })
                                }
                            />
                        ) : (
                            <Swiper
                                className="w-full max-w-full"
                                autoplay={false}
                                autoHeight
                                loop={child.images.length > 1}
                                modules={[
                                    Navigation,
                                    Pagination,
                                    A11y,
                                    Autoplay,
                                ]}
                                spaceBetween={0}
                                slidesPerView={1}
                                pagination={{
                                    clickable: true,
                                    el: `#swiper-bullet-container-${child.id}`,
                                    bulletClass: "swiper-custom-bullet-rect",
                                    bulletActiveClass:
                                        "swiper-custom-bullet-rect--active",
                                }}
                            >
                                {child.images.map((image, index) => (
                                    <SwiperSlide key={image.id}>
                                        <img
                                            src={image.path}
                                            className="w-full h-48 rounded-lg object-cover cursor-pointer"
                                            onClick={() =>
                                                onClickImage?.({
                                                    index,
                                                    images: child.images,
                                                    name: child.name,
                                                    description: child.description,
                                                })
                                            }
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        )}

                        <div
                            id={`swiper-bullet-container-${child.id}`}
                            className="flex items-center justify-center gap-2 mt-2"
                        />

                        <Markdown className="mt-2 text-sm text-gray-500">
                            {child?.description}
                        </Markdown>
                    </div>
                ))}
            </div>
        </div>
    );
}
